import React from "react";

// reactstrap components
// import { Container, Row, Col } from "reactstrap";

// core components

function Images() {
  return (
    <>
      <div class="homecontent">
        <p>
          Intertek’s diverse range of inspection services can provide trusted support for your products, projects and processes.
        </p>
        <p>
          Independent third-party inspections help clients around the world protect their financial, branding and legal interests throughout the entire supply chain - from raw materials and finished goods to plant facilities and assets. We offer inspection services to manufacturers, retailers, traders, plant operators, governments and other buyers and sellers of materials and products in the world’s markets.
        </p>

        
        <p>
          Inspections help minimise the risk of defective products by ensuring they meet both customer standards and industry and government regulations. This serves to protect your business interests, help manage your risk and ensure quality products are manufactured and delivered to their final destination at the specifications of the customer.
        </p>

        
        <p>
          Experienced inspectors help identify products and shipments which may contain non-standard or non-compliant components and materials. Products and materials that we routinely test and inspect include consumer goods such as clothes, toys, cosmetics, and food, to high-value bulk commodity cargoes such as agricultural products, crude oil, chemicals and refined petroleum products during critical transportation, custody transfer and storage operations.
        </p>

                
        <p>
         We also support the life management of plant facilities such as power plants and oil refineries with inspection and testing, ensuring that your assets are operating safely and reliably.
        </p>
        {/* <Container>
          <Row>
            <Col md="5">
              <div className="sw_home_img">
                <img
                  alt="..."
                  src={require("assets/img/dispensing_vector_small.png")}
                ></img>
              </div>
            </Col>
            <Col md="7">
              <div className="sw_home_content">
                <p>
                 This is Inspection home page. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </p>

                <p>
                 This is Inspection home page. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
              </div>
            </Col>
          </Row>
        </Container> */}
      </div>
    </>
  );
}

export default Images;
